<script>
    import analyticsServico from '../servico';

    export default {
      components: { },
      name: 'analytics-projeto',
      data() {
        return {
          animated: true,
          usuario: this.$storage.usuario(),
          configuracao: this.$storage.configuracao(),
          solicitacoes: [],
          carregando: true,
          dataAtual: new Date(new Date().toISOString().split('T')[0]),

          type: chartType,
          dataBase: chartData,
          options: chartOptions,
        }
      },
      computed: {
        dia() {
            return this.dataAtual.getDate();
        },
        diaSemana() {
            return this.dataAtual.getUTCDay();
        },
        mes() {
            return this.dataAtual.getMonth();
        },
        ano() {
           return this.dataAtual.getFullYear();
        },
        solHoje() {
            return this.solicitacoes.filter(s => s.diaSolicitacao == this.dia && s.mesSolicitacao == this.mes && s.anoSolicitacao == this.ano).length.toLocaleString('pt-BR');
        },
        solSemana() {            
            const primeiroDia = moment.utc(this.dataAtual).add(-this.diaSemana,'days') 
            const ultimoDia = moment.utc(this.dataAtual).add((6 - this.diaSemana),'days') 
          
            return this.solicitacoes.filter(s => s.dataSolicitacao >= primeiroDia && s.dataSolicitacao <= ultimoDia).length.toLocaleString('pt-BR');
        },
        solMes() {
            return this.solicitacoes.filter(s => s.mesSolicitacao == this.mes && s.anoSolicitacao == this.ano).length.toLocaleString('pt-BR');
        },
        solAno() {
            return this.solicitacoes.filter(s => s.anoSolicitacao == this.ano).length.toLocaleString('pt-BR');
        },
        // Arrays
        solHojeArray() {
            return this.solicitacoes.filter(s => s.diaSolicitacao == this.dia && s.mesSolicitacao == this.mes && s.anoSolicitacao == this.ano);
        },
        solSemanaArray() {    
            const primeiroDia = moment.utc(this.dataAtual).add(-this.diaSemana,'days') 
            const ultimoDia = moment.utc(this.dataAtual).add((6 - this.diaSemana),'days') 
          
            return this.solicitacoes.filter(s => s.dataSolicitacao >= primeiroDia && s.dataSolicitacao <= ultimoDia);
        },
        solMesArray() {
            return this.solicitacoes.filter(s => s.mesSolicitacao == this.mes && s.anoSolicitacao == this.ano);
        },
        solAnoArray() {
            return this.solicitacoes.filter(s => s.anoSolicitacao == this.ano);
        },
      },
      methods: {
        carregar: function() {
          this.carregando = true;

          analyticsServico
            .carregarProjeto()
            .then(solicitacoes => {
              this.carregando = false;
              this.solicitacoes = solicitacoes;

              this.solicitacoes.forEach(sol => { sol.dataSolicitacao = new Date(sol.dataSolicitacao.split('T')[0]) });
            });
        },        
      },
      created() {
        this.carregar();
      },
      mounted() {
        this.$root.tituloDaPagina = "Analytics - Projeto"

        this.$root.botaoAcaoMostrar = false;
        this.$root.botaoRetrocederMostrar = false;
        this.$root.botaoRetrocederRota = '';
      },
    }
</script>

<template>
    <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
        <div>
            {{solMesArray}}
            <div class="row">
                <div class="col-lg-3">
                    <div class="ibox ">
                        <div class="ibox-title">
                            <div class="ibox-tools">
                                <span class="label label-success float-right" style="float: right;">Hoje</span>
                            </div>
                            <h5>Solicitações</h5>
                        </div>
                        <div class="ibox-content">
                            <h1 class="no-margins">{{solHoje}}</h1>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="ibox ">
                        <div class="ibox-title">
                            <div class="ibox-tools">
                                <span class="label label-info float-right" style="float: right;">Semanal</span>
                            </div>
                            <h5>Solicitações</h5>
                        </div>
                        <div class="ibox-content">
                            <h1 class="no-margins">{{solSemana}}</h1>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="ibox ">
                        <div class="ibox-title">
                            <div class="ibox-tools">
                                <span class="label label-primary float-right" style="float: right;">Mensal</span>
                            </div>
                            <h5>Solicitações</h5>
                        </div>
                        <div class="ibox-content">
                            <h1 class="no-margins">{{solMes}}</h1>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="ibox ">
                        <div class="ibox-title">
                            <div class="ibox-tools">
                                <span class="label label-warning float-right" style="float: right;">Anual</span>
                            </div>
                            <h5>Solicitações</h5>
                        </div>
                        <div class="ibox-content">
                            <h1 class="no-margins">{{solAno}}</h1>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/analytics/compartilhado/AnalyticsProjeto.vue